import {SET_BOOKINGS, SET_TELEGRAM_LIST, SET_WEBINAR_LIST} from '../types';
import { requestHandler } from '../../routes';
import { setSnackBar } from './other';

export const setTelegramList = (data) => ({
  type: SET_TELEGRAM_LIST,
  data,
});

export const getTelegramList = () => async (dispatch) => {
  const data = await requestHandler.send({
    url: '/api/telegram/getRequestsList',
    method: 'GET',
  });

  dispatch(setTelegramList(data));
  return data;
};


export const updateWebinar = (id, data) => async () => {
  const result = await requestHandler.send({
    url: `/api/webinar/update/${id}`,
    method: 'PATCH',
    data,
  });

  console.log(result);
  return result;
};

export const createZoomMeeting = (id) => async () => {
  const data = await requestHandler.send({
    url: `/api/webinar/createZoomMeeting/${id}`,
    method: 'GET',
  });

  console.log(data);
  return data;
};


export const updateZoomMeeting = (id) => async () => {
  const data = await requestHandler.send({
    url: `/api/webinar/updateZoomMeeting/${id}`,
    method: 'PATCH',
  });

  console.log(data);
  return data;
};

export const deleteZoomMeeting = (id) => async () => {
  const data = await requestHandler.send({
    url: `/api/webinar/deleteZoomMeeting/${id}`,
    method: 'DELETE',
  });

  console.log(data);
  return data;
};
